var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('nav-bar',{attrs:{"isCheckout":_vm.isCheckout}}),_c('v-content',[_c('router-view')],1),_c('app-footer',{attrs:{"isCheckout":_vm.isCheckout}}),_c('snackbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }